export const API_URL = process.env.NODE_ENV === "production"
? "https://backend-alijawad06s-projects.vercel.app"
: "http://localhost:4000";